import { fetchCompleteType } from './fetchCompleteType';
import { popupShareThisCompany } from './popupShareThisCompany';
import { popupFollowPopularCompany } from './popupFollowPopularCompany';

/**
 * フォロー後、受け取った企業IDに合わせてポップアップ種類の出し分けをする
 *
 * @param {string} companyId 企業ID
 */
export const sharePopup = (companyId) => {
  function decidePopupType () {
    fetchCompleteType(companyId).then(data => {
      switch (data.complete_type) {
        case 'share':
          popupShareThisCompany(companyId);
          break;
        case 'follow':
          // レスポンスの中に企業リストがない場合はpopupを表示せず
          if (data.company_list === false) {
            popupShareThisCompany(companyId);
          } else {
            popupFollowPopularCompany(data.company_list);
          }
          break;
        default:
          return false;
      }
    });
  }

  function init () {
    decidePopupType();
  }

  init();
};
